module.exports = __webpack_public_path__ + "img/SES_205118804.2289b8ab.jpg";